var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3939 7.68191C17.3939 7.30289 17.2433 6.9394 16.9753 6.67139C16.7073 6.40338 16.3438 6.25282 15.9648 6.25282H11.4489L12.1348 2.98733C12.1491 2.91587 12.1563 2.83727 12.1563 2.75867C12.1563 2.46571 12.0348 2.19418 11.8419 2.00125L11.0844 1.25098L6.3827 5.95271C6.11832 6.21709 5.96112 6.57436 5.96112 6.96737V14.1129C5.96112 14.4919 6.11168 14.8554 6.37969 15.1234C6.6477 15.3914 7.0112 15.5419 7.39022 15.5419H13.8212C14.4142 15.5419 14.9216 15.1847 15.1359 14.6702L17.2939 9.63263C17.3582 9.46828 17.3939 9.29679 17.3939 9.11101V7.68191ZM1.67383 15.5419H4.53202V6.96737H1.67383V15.5419Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewLike);
export default __webpack_public_path__ + "static/media/previewLike.072cb71990baf240a69dc9ff3261a5a8.svg";
export { ForwardRef as ReactComponent };